import { createStore } from '@store/createStore';

const useAITranslateStore = createStore(
  (set) => ({
    targetLanguage: '',
    profileLanguageName: '',
    profileLanguageIsoCode: '',
    networkAiTextBlocks: {},

    actions: {
      setAITranslateTargetLanguage: (targetLanguage) => set({ targetLanguage }),
      setAITranslateProfileLanguageName: (profileLanguageName) => set({ profileLanguageName }),
      setAITranslateProfileLanguageIsoCode: (profileLanguageIsoCode) => set({ profileLanguageIsoCode }),
      setAITranslateNetworkAiTextBlocks: (networkAiTextBlocks) => set({ networkAiTextBlocks }),
    },
  }),
  'AITranslateStore',
);

export const useAITranslateActions = () => useAITranslateStore((state) => state.actions);

export const selectAITranslateTargetLanguage = () => useAITranslateStore((state) => state.targetLanguage);
export const selectAITranslateProfileLanguageName = () =>
  useAITranslateStore((state) => state.profileLanguageName);
export const selectAITranslateProfileLanguageIsoCode = () =>
  useAITranslateStore((state) => state.profileLanguageIsoCode);
export const selectAITranslateNetworkAiTextBlocks = () =>
  useAITranslateStore((state) => state.networkAiTextBlocks);
